import { IMedsusCID } from '../../modules/types/Medsus';
import httpClient from '../httpClient';

/**
 * Busca todos os registros de CIDs MedSUS.
 */
export const getAllMedsusCid = async (): Promise<IMedsusCID[]> => {
  try {
    const response = await httpClient.get('/api/medsuscid');
    // Backend retorna { message, registros }
    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error(
      'Erro ao obter lista de CIDs MedSUS: ' + error.response?.data.message,
    );
  }
};

/**
 * Busca todos os registros de CIDs pelo ID do Diretriz.
 */
export const getAllMedsusCidByDiretrizVmp = async (diretrizId: string) => {
  try {
    const response = await httpClient.get(
      `/api/medsuscid/diretriz/${diretrizId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

/**
 * Busca um CID específico pelo ID.
 */
export const getMedsusCidById = async (
  id: string | number,
): Promise<IMedsusCID> => {
  try {
    const response = await httpClient.get(`/api/medsuscid/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      'Erro ao obter CID MedSUS: ' + error.response?.data.message,
    );
  }
};

/**
 * Cria um novo CID MedSUS.
 */
export const handleCreateMedsusCid = async (form: IMedsusCID): Promise<any> => {
  try {
    const response = await httpClient.post('/api/medsuscid', form);
    console.log(response);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error(
      'Erro ao criar CID MedSUS: ' + error.response?.data.message,
    );
  }
};

/**
 * Atualiza um CID MedSUS existente.
 */
export const handleUpdateMedsusCid = async (form: IMedsusCID): Promise<any> => {
  try {
    const response = await httpClient.patch(`/api/medsuscid/${form.id}`, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error(
      'Erro ao atualizar CID MedSUS: ' + error.response?.data.message,
    );
  }
};

/**
 * Realiza exclusão lógica (soft delete) de um CID MedSUS.
 */
export const handleDeleteMedsusCid = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/medsuscid/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error(
      'Erro ao excluir CID MedSUS: ' + error.response?.data.message,
    );
  }
};
